import { createFileRoute } from "@tanstack/react-router"
import { validateInstructorSectionSearch } from "@/utils/instructorSectionSearch"
import { queryClient } from "@/queryClient"
import { getCourseOptions } from "@/client/@tanstack/react-query.gen"
import CourseAssessmentCreate from "@/routes/-pages/CourseAssessmentCreate"
import { runBackendModePrefetch } from "@/utils/routePrefetch"

export const Route = createFileRoute("/instructor/course/$courseId/assessment/create")({
  validateSearch: validateInstructorSectionSearch,
  loader: ({ params }) => {
    return runBackendModePrefetch(() =>
      queryClient.prefetchQuery(getCourseOptions({ path: { course_id: params.courseId } })),
    )
  },
  component: CourseAssessmentCreate,
})
